const LOCK_KEY = 'c2_terminal_locked';
const LOCK_MODE_KEY = 'c2_terminal_lock_mode';
const RETURN_PATH_KEY = 'c2_terminal_return_path';
const LOCKED_USER_KEY = 'c2_terminal_locked_user';

export type TerminalLockMode = 'lock' | 'switch';

export function persistTerminalLock(mode: TerminalLockMode, returnPath: string, lockedUserId?: string) {
  sessionStorage.setItem(LOCK_KEY, '1');
  sessionStorage.setItem(LOCK_MODE_KEY, mode);
  sessionStorage.setItem(RETURN_PATH_KEY, returnPath);
  if (lockedUserId) sessionStorage.setItem(LOCKED_USER_KEY, lockedUserId);
}

export function clearTerminalLockStorage() {
  sessionStorage.removeItem(LOCK_KEY);
  sessionStorage.removeItem(LOCK_MODE_KEY);
  sessionStorage.removeItem(RETURN_PATH_KEY);
  sessionStorage.removeItem(LOCKED_USER_KEY);
}

export function readTerminalLockFromStorage(): {
  locked: boolean;
  mode: TerminalLockMode | null;
  returnPath: string | null;
  lockedUserId: string | null;
} {
  const locked = sessionStorage.getItem(LOCK_KEY) === '1';
  const mode = sessionStorage.getItem(LOCK_MODE_KEY) as TerminalLockMode | null;
  return {
    locked,
    mode: mode === 'lock' || mode === 'switch' ? mode : null,
    returnPath: sessionStorage.getItem(RETURN_PATH_KEY),
    lockedUserId: sessionStorage.getItem(LOCKED_USER_KEY),
  };
}
